import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const Wrapper = styled.div`
  text-align: center;
  margin: 60px 0;
`

export const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${myPalette.midnightBlue.main};
  margin-bottom: 16px;
`

export const Description = styled.div`
  font-size: 14px;
  color: ${myPalette.midnightBlue.main};
`
